import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const molecularWeightTool: Tool = {
  id: "molecular-weight",
  name: () => m.mw_tool_name(),
  description: () => m.mw_tool_description(),
  icon: "🧬",
  basePath: "/molecular-weight",
  status: "stable",
  tags: [
    "calculator",
    "chemistry",
    "science",
    "lab",
    "molar-mass",
    "molecular-weight",
  ],
};
